import $ from 'jquery';

export default function applyAccessRoles($container, user) {
  $container
    .find('[data-access-role]')
    .each((_, el) => {
      const $el = $(el);

      const accessRoles = ($el.data('accessRole') || '').split(',');
      const isForAnonymous = accessRoles.some((role) => role === 'anonymous');
      const isForAdultCityzens = accessRoles.some((role) => role === 'cityzens');
      const isForCityzensU13 = accessRoles.some((role) => role === 'cityzensU13');
      const isForAnonymousOnly = accessRoles.every((role) => role === 'anonymous');
      const isForAdultCityzensOnly = accessRoles.every((role) => role === 'cityzens');
      const isForCityzensU13Only = accessRoles.every((role) => role === 'cityzensU13');

      if (
        (isForAnonymousOnly && user)
        || (isForAdultCityzensOnly && (!user || (user && user.u13)))
        || (isForCityzensU13Only && (!user || (user && !user.u13)))
        || (((isForAdultCityzens || isForCityzensU13) && !isForAnonymous) && !user)
      ) {
        $el.addClass('is-hidden');
      }
    });
  const event = new Event('main-nav-access-roles-applied');
  document.dispatchEvent(event);
}
